import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProductRepository from "src/repository/ProductRepository";
import ProductDetailAPICall from "../../../service/ProductDetailAPICall";

export const product_category_list = createAsyncThunk('product_category_list', async () => {
    return await new ProductDetailAPICall().getProductCategory();
});

export const check_if_design_available = createAsyncThunk('check_if_design_available', async (params) => {
    return await new ProductDetailAPICall().checkIfDesignsAvailable(params.itemNumber, params.speedBoat)
})

export const check_designs_exist = createAsyncThunk('check_designs_exist', async (params) => {
    return await new ProductDetailAPICall().checkDesignsExist(params.itemNumber)
})

export const get_all_design_data = createAsyncThunk('get_all_design_data', async (params) => {
    return await new ProductDetailAPICall().getAllDesignsData(params.itemNumberArray, params.speedBoat)
})

export const product_document_list = createAsyncThunk('product_document_list', async (params) => {
    return await new ProductRepository().getProductDocumentList(params.filter, params.top, params.orderby);
});

export const product_documents_count = createAsyncThunk('product_documents_count', async (params) => {
    return await new ProductRepository().getProductDocumentCount(params.filter);
});

export const product_images_list = createAsyncThunk('product_images_list', async (params) => {
    return await new ProductRepository().getProductDocumentImageList(params.filter, params.top, params.variantAssetSearchType);
});

export const alternative_product_by_variant_number_list = createAsyncThunk('product_alternative_data_list', async (params) => {
    return await new ProductRepository().getAlternativeProductByVariantNumber(params.ItemNum, params.orderBy, params.top, params.skip);
});

export const alternative_products_count = createAsyncThunk('product_alternative_products_count', async (params) => {
    return await new ProductRepository().getAlternativeProductCountByVariantNumber(params.ItemNum);
});

export const get_product_category_external_search = createAsyncThunk('get_product_category_external_search', async (params) => {
    return await new ProductDetailAPICall().getProductManufactureExternalSearch(params.requestUrl)
})
const initialState = {
    setProductDetail: {
        data: []
    },
    documentData: {},
    imagesData: {},
    alternativeProductData: {},
    alternativeProductCount: 0,
    documentCount: 0,
    designHubData: {}
};

const slice = createSlice({
    name: "ProductDetail",
    initialState: initialState,
    reducers: {
        setProductDetail: {
            reducer: (state, action) => {
                state.setProductDetail.data = action.payload.data
            },
        },
        clearAlternativeProductData: (state, action) => {
            state.alternativeProductData = initialState.alternativeProductData
        },
    },
    extraReducers: {
        [product_document_list.fulfilled]: (state, { payload }) => {
            state.documentData = payload;
            return state;
        },
        [product_document_list.rejected]: (state, { payload }) => {
        },
        [product_documents_count.fulfilled]: (state, { payload }) => {
            state.documentCount = payload;
            return state;
        },
        [product_images_list.fulfilled]: (state, { payload }) => {
            state.imagesData = payload.Data;
            return state;
        },
        [alternative_product_by_variant_number_list.fulfilled]: (state, { payload }) => {
            state.alternativeProductData = payload;
            return state;
        },
        [alternative_products_count.fulfilled]: (state, { payload }) => {
            state.alternativeProductCount = payload;
            return state;
        },
        [product_images_list.rejected]: (state, { payload }) => {
        },
        [check_designs_exist.fulfilled]: (state, { payload }) => {
            state.designHubData = payload;
            return state;
        },
        [check_designs_exist.rejected]: (state, { payload }) => {
        },
    },
});

export let { setProductDetail, clearAlternativeProductData } = slice.actions;

export default slice.reducer;
